import { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import { canAccessPath, getDefaultAllowedPath } from '../../utils/permissions';

export default function ProtectedRoute({ children, path }) {
  const [, setTick] = useState(0);

  useEffect(() => {
    const onPermsUpdated = () => setTick((t) => t + 1);
    window.addEventListener('qmetrix-permissions-updated', onPermsUpdated);
    return () => window.removeEventListener('qmetrix-permissions-updated', onPermsUpdated);
  }, []);

  if (!canAccessPath(path)) {
    return <Navigate to={getDefaultAllowedPath()} replace />;
  }
  return children;
}

ProtectedRoute.propTypes = {
  children: PropTypes.node.isRequired,
  path: PropTypes.string.isRequired,
};
